/**
 * Do not edit directly, this file was auto-generated.
 * Generated on Thu, 26 Jun 2025 06:28:09 GMT
 */


export const AliasColorBrandPrimary = "hsl(205.6, 59.7%, 52.4%)";
export const AliasColorTextPrimary = "hsl(205.6, 6%, 60%)";
export const AliasColorTextSecondary = "hsl(205.6, 6%, 35%)";
export const AliasColorTextTertiary = "hsl(205.6, 5%, 65%)";
export const AliasColorTextQuarternary = "hsl(205.6, 15%, 85%)";
export const AliasColorTextAccent = "#ffffff";
export const AliasColorBorderWeak = "#373a3f";
export const AliasColorBorderDefault = "hsl(205.6, 6%, 35%)";
export const AliasColorBorderStrong = "hsl(205.6, 6%, 55%)";
export const AliasColorBorderVivid = "#ffffff";
export const AliasColorBorderFocus = "hsl(205.6, 59.7%, 52.4%)";
export const AliasColorDanger = "hsl(359, 60%, 50%)";
export const AliasColorCaution = "hsl(31.81, 100%, 57.84%)";
export const AliasColorCautionDark = "hsl(31.81, 100%, 40%)";
export const AliasColorOk = "hsl(138, 60%, 40%)";
export const AliasColorInfo = "hsl(205.6, 59.7%, 52.4%)";
export const AliasColorBackgroundBase = "#1e2124";
export const AliasColorBackgroundSecondary = "#23262a";
export const AliasColorBackgroundTertiary = "#373a3f";
export const AliasColorBackgroundQuarternary = "hsl(205.6, 9%, 20%)";
export const AliasColorBackgroundQuinary = "#272a2f";
export const AliasColorBackgroundElevationNegative = "#000000";
export const AliasColorBackgroundOverlayBlocked = "#000000";
export const AliasColorBackgroundOverlayPopup = "#000000";
export const AliasColorBackgroundHighlight10 = "#ffffff";
export const AliasColorBackgroundHighlight15 = "#ffffff";
export const AliasColorBackgroundHighlight25 = "#ffffff";
export const AliasColorBackgroundBlockHeader = "#23262a";
export const AliasColorBackgroundBlockContent = "#272a2f";
export const AliasColorBackgroundBlockFooter = "#23262a";
export const AliasColorFontLink = "hsl(205.6, 59.7%, 52.4%)";
export const AliasColorFontTableHeaderBase = "#ffffff";
export const AliasColorFontTableCellPrimary = "hsl(205.6, 6%, 60%)";
export const AliasColorFontTableCellSecondary = "hsl(205.6, 6%, 35%)";
export const AliasColorFontTableCellActive = "hsl(172, 59%, 39%)";
export const AliasColorFontTableCellCaution = "hsl(31.81, 100%, 57.84%)";
export const AliasColorFontTableCellDanger = "hsl(359, 60%, 50%)";
export const AliasColorFontTableCellLink = "hsl(205.6, 59.7%, 52.4%)";
